import { render, staticRenderFns } from "./deleteProduct.vue?vue&type=template&id=0d83df92"
import script from "./deleteProduct.vue?vue&type=script&lang=js"
export * from "./deleteProduct.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports